import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ParserPipe } from './parser/parser.pipe';
import { WebSiteComponent } from './web-site-component/web-site.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  ManikLoaderComponent,
  ManikDataLoaderComponent,
} from './manik-library/manik-loader/manik-loader.component';
import { ClickToCallComponent } from './ModelPopup/click-to-call/click-to-call.component';
import { GrabADealComponent } from './ModelPopup/grab-adeal/grab-adeal.component';
import { RateAndReviewComponent } from './ModelPopup/rate-and-review/rate-and-review.component';
import { ReportBusinessComponent } from './ModelPopup/report-business/report-business.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {
  HeaderInterceptor,
  ErrorInterceptor,
} from './manik-library/auth.guard';
import { PaytmPaymentResponseComponent } from './paytm-payment-response/paytm-payment-response.component';
import { BookingFormComponent } from './TestComponents/booking-form/booking-form.component';

import { BookingCalendarComponent } from './NovaBooking/booking-calendar/booking-calendar.component';
import { BuyerPassCodeComponent } from './buyer-pass-code/buyer-pass-code.component';
import { VisitorHandlerComponent } from './ModelPopup/visitor-handler/visitor-handler.component';
import { OtpHandlerComponent } from './ModelPopup/otp-handler/otp-handler.component';
import { BookmarkComponent } from './ModelPopup/bookmark/bookmark.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SmartcardSiteComponent } from './smartcard-site/smartcard-site.component';
import { MatSliderModule } from '@angular/material/slider';

import { MatStepperModule } from '@angular/material/stepper';
import { SiteEditComponent } from './ModelPopup/site-edit/site-edit.component';
import { MicrositeMenuComponent } from './ModelPopup/site-edit/microsite-menu/microsite-menu.component';
import { MicrositeHighlighter1Component } from './ModelPopup/site-edit/microsite-highlighter1/microsite-highlighter1.component';
import { ECommerceEditComponent } from './ModelPopup/site-edit/Ecommerce-Edit/ecommerce.edit.component';
import { MicrositeGalleryComponent } from './ModelPopup/site-edit/microsite-gallery/microsite-gallery.component';
import { MicrositeBookComponent } from './ModelPopup/site-edit/microsite-book/microsite-book.component';
import { MicrositeCandidComponent } from './ModelPopup/site-edit/microsite-candid/microsite-candid.component';
import { MicrositeSettingsEditComponent } from './ModelPopup/site-edit/microsite-settings/microsite-settings.edit.component';
import { SmartButtonComponent } from './smart-button/smart-button.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  ManikButtonLoader,
  GenericSafePipe,
} from './manik-library/ManikEntityFE';
import { MicrositeAboutComponent } from './ModelPopup/site-edit/microsite-about/microsite-about.component';
import {
  SafePipe,
  ImageHandlerComponent,
} from './smart-media-handler/image-handler.component';
import { SliderModule } from 'angular-image-slider';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { IconPickerModule } from 'ngx-icon-picker';
import { MicrositeSettingsComponent } from './ModelPopup/site-edit/microsite-settings/microsite-settings.component';
import { CandidPhotosComponent } from './ModelPopup/site-edit/candid-photos/candid-photos.component';
import { EditEnquiryFormComponent } from './ModelPopup/site-edit/edit-enquiry-form/edit-enquiry-form.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { HappyornotComponent } from './happyornot/happyornot.component';
import { EnquiryComponent } from './enquiry/enquiry.component';
import { EcommOrderHandleComponent } from './ecomm-order-handle/ecomm-order-handle.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HonoHeaderComponent } from './shared/hono-header/hono-header.component';
@NgModule({
  declarations: [
    AppComponent,
    ParserPipe,
    WebSiteComponent,
    ManikLoaderComponent,
    ManikDataLoaderComponent,
    ClickToCallComponent,
    GrabADealComponent,
    RateAndReviewComponent,
    ReportBusinessComponent,
    //ECommCheckoutComponent,
    PaytmPaymentResponseComponent,
    BookingFormComponent,
    BookingCalendarComponent,
    BuyerPassCodeComponent,
    VisitorHandlerComponent,
    OtpHandlerComponent,
    BookmarkComponent,
    CheckoutComponent,
    SmartcardSiteComponent,
    SiteEditComponent,
    MicrositeMenuComponent,
    MicrositeHighlighter1Component,
    ECommerceEditComponent,
    CandidPhotosComponent,
    MicrositeGalleryComponent,
    MicrositeBookComponent,
    MicrositeCandidComponent,
    MicrositeSettingsEditComponent,
    MicrositeSettingsComponent,
    MicrositeAboutComponent,
    SmartButtonComponent,
    ManikButtonLoader,
    SafePipe,
    GenericSafePipe,
    ImageHandlerComponent,
    EditEnquiryFormComponent,
    FeedbackComponent,
    HappyornotComponent,
    EnquiryComponent,
    EcommOrderHandleComponent,
    HeaderComponent,
    FooterComponent,
    HonoHeaderComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpModule,
    MatDialogModule,
    MatTooltipModule,
    DragDropModule,
    MatSelectModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatStepperModule,
    SliderModule,
    AngularEditorModule,
    IconPickerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
  ],
  exports: [MatStepperModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ClickToCallComponent,
    GrabADealComponent,
    RateAndReviewComponent,
    ReportBusinessComponent,
    CheckoutComponent,
    SiteEditComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
